/** `/register` — create an account, then go and look at your inbox. */

import { Link, useNavigate } from "react-router-dom";

import { useSession } from "../../auth/AuthProvider";
import { AuthCard } from "./AuthCard";
import { RegisterForm } from "./RegisterForm";

export function Register() {
  const { api } = useSession();
  const navigate = useNavigate();

  return (
    <AuthCard
      title="Create your account"
      intro="An account keeps track of your licence and which machines it covers. Backups themselves stay on your own storage — nothing is uploaded to us."
      footer={
        <>
          Already have one? <Link to="/login">Sign in</Link>.
        </>
      }
    >
      <RegisterForm
        api={api}
        onRegistered={(email) => {
          // The address travels with the navigation so the next page can show
          // it back. Registration deliberately leaves no session, so there is
          // nothing else to carry.
          navigate("/check-email", { replace: true, state: { email, reason: "register" } });
        }}
      />
    </AuthCard>
  );
}
